<template>
    <div>
        <div id="smoothpage" class="wrapper">

            <menu-transparent :transparent="false"></menu-transparent>

            <!-- ========== HEADER ========== -->
            <my-header :transparent="false"></my-header>

            <router-view></router-view>

            <my-footer></my-footer>

        </div>

        <!-- ========== BACK TO TOP ========== -->
        <div id="back_to_top">
            <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>

        <!-- ========== NOTIFICATION ========== -->
        <div id="notification"></div>
    </div>
</template>

<script>
    import menuTransparent from '../../components/menuTransparent/MenuTransparent.vue';
    import myHeader from '../../components/headerTransparent/HeaderTransparent.vue';
    import footer from '../../components/footer/Footer.vue';
    export default {
        components : {
            'menu-transparent' : menuTransparent,
            'my-header' : myHeader,
            'my-footer' : footer,
        }
    }
</script>


// WEBPACK FOOTER //
// Site.vue?857fc9e0